export default __webpack_public_path__ + "static/media/call-afp-habitat.96086051.gif";